import React from 'react';
import { Button } from '../ui/button';
import { Card } from '../ui/card';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Calculator } from 'lucide-react';

const QuoteTab = ({ rateCard, quoteVehicle, setQuoteVehicle, quoteHours, setQuoteHours, quotePricing, setQuotePricing, quoteDriverRate, setQuoteDriverRate, quoteRentalCost, setQuoteRentalCost, quoteIsRental, setQuoteIsRental, quoteResult, onCalculate }) => {
  return (
    <div className="grid lg:grid-cols-2 gap-6">
      <Card className="p-6 border-gray-200 bg-white">
        <h3 className="text-lg font-bold mb-4 flex items-center gap-2"><Calculator className="h-5 w-5 text-red-600" />Dispatcher Quote Engine</h3>
        <div className="space-y-4">
          <div>
            <Label>Vehicle Type</Label>
            <Select value={quoteVehicle} onValueChange={setQuoteVehicle}>
              <SelectTrigger data-testid="quote-vehicle"><SelectValue /></SelectTrigger>
              <SelectContent>
                {Object.entries(rateCard).map(([key, val]) => (
                  <SelectItem key={key} value={key}>{val.name} — ${val.rate}/hr</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <Label>Hours</Label>
              <Input type="number" value={quoteHours} onChange={e => setQuoteHours(parseFloat(e.target.value) || 0)} data-testid="quote-hours" />
              {rateCard[quoteVehicle] && <p className="text-xs text-gray-400 mt-1">Min: {rateCard[quoteVehicle].min_hours}hr</p>}
            </div>
            <div>
              <Label>Pricing</Label>
              <Select value={quotePricing} onValueChange={setQuotePricing}>
                <SelectTrigger data-testid="quote-pricing"><SelectValue /></SelectTrigger>
                <SelectContent>
                  <SelectItem value="retail">Retail</SelectItem>
                  <SelectItem value="member">Member (-20%)</SelectItem>
                </SelectContent>
              </Select>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <Label>Driver Rate ($/hr)</Label>
              <Input type="number" value={quoteDriverRate} onChange={e => setQuoteDriverRate(parseFloat(e.target.value) || 0)} data-testid="quote-driver" />
            </div>
            <div>
              <Label className="flex items-center gap-2">
                <input type="checkbox" checked={quoteIsRental} onChange={e => setQuoteIsRental(e.target.checked)} />
                Rental Vehicle
              </Label>
              {quoteIsRental && <Input type="number" value={quoteRentalCost} onChange={e => setQuoteRentalCost(parseFloat(e.target.value) || 0)} placeholder="Rental cost" className="mt-2" />}
            </div>
          </div>
          <Button onClick={onCalculate} className="w-full bg-red-600 hover:bg-red-700" data-testid="calculate-quote-btn">
            <Calculator className="h-4 w-4 mr-2" />Calculate Quote
          </Button>
        </div>
      </Card>

      {quoteResult && (
        <Card className="p-6 border-gray-200 bg-white" data-testid="quote-result">
          <h3 className="text-lg font-bold mb-4">Quote Result</h3>
          <div className="bg-gray-50 rounded-lg p-4 space-y-3">
            <div className="flex justify-between text-sm"><span className="text-gray-500">Vehicle:</span><span className="font-bold">{quoteResult.vehicle}</span></div>
            <div className="flex justify-between text-sm"><span className="text-gray-500">Effective Hours:</span><span>{quoteResult.effective_hours} hrs</span></div>
            <div className="flex justify-between text-sm"><span className="text-gray-500">Applied Rate:</span><span>${quoteResult.applied_rate}/hr {quoteResult.pricing_type === 'member' && <span className="text-green-600 text-xs ml-1">(Member)</span>}</span></div>
            <div className="border-t pt-3">
              <div className="flex justify-between items-center"><span className="text-gray-500">Revenue:</span><span className="font-bold text-lg text-green-700">${quoteResult.revenue}</span></div>
            </div>
            <div className="flex justify-between text-sm"><span className="text-gray-500">Driver Cost:</span><span className="text-red-600">-${quoteResult.driver_cost}</span></div>
            {quoteResult.rental_cost > 0 && <div className="flex justify-between text-sm"><span className="text-gray-500">Rental Cost:</span><span className="text-red-600">-${quoteResult.rental_cost}</span></div>}
            <div className="border-t pt-3 space-y-2">
              <div className="flex justify-between items-center"><span className="font-semibold">Net Profit:</span><span className="font-bold text-xl text-blue-700">${quoteResult.profit}</span></div>
              <div className="flex justify-between text-sm"><span className="text-gray-500">Margin:</span><span className={`font-bold ${quoteResult.margin_percent >= 50 ? 'text-green-600' : quoteResult.margin_percent >= 30 ? 'text-yellow-600' : 'text-red-600'}`}>{quoteResult.margin_percent}%</span></div>
              <div className="flex justify-between text-sm"><span className="text-gray-500">Profit/Hour:</span><span className="font-semibold">${quoteResult.profit_per_hour}/hr</span></div>
            </div>
          </div>
        </Card>
      )}
    </div>
  );
};

export default QuoteTab;
